import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';

export function getPaginatorIntl(translateService: TranslocoService) {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = translateService.translate('home.paginator.countLabel');
    paginatorIntl.nextPageLabel = translateService.translate('home.paginator.nextPage');
    paginatorIntl.previousPageLabel = translateService.translate('home.paginator.previousPage');

    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 ${translateService.translate('home.paginator.rangeLabel')} ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;

        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} ${translateService.translate('home.paginator.rangeLabel')} ${length}`;
    };

    return paginatorIntl;
}
